import { qualificationText } from './qualificationTexts';

const BLOCK_CLASS = 'skeleton-bar rounded-md';

// One block per tab of the form, roughly as wide as its label.
const TAB_WIDTHS = ['w-28', 'w-32', 'w-24', 'w-20'];

const SkeletonField = ({ fieldClassName = 'h-10' }) => (
  <div className="flex flex-col gap-1.5">
    <div className={`h-4 w-24 ${BLOCK_CLASS}`} />
    <div className={`w-full ${fieldClassName} ${BLOCK_CLASS}`} />
  </div>
);

/** Stands in for the subtitle line of the header while the qualification loads. */
export const QualificationHeaderSkeleton = () => (
  <div aria-hidden="true" className={`mt-2 h-4 w-3/4 ${BLOCK_CLASS}`} />
);

/**
 * The informations tab's shape (tabs, name, description, codes, sector,
 * mission preferences) until getQualificationByID first answers.
 */
const QualificationFormSkeleton = () => (
  <div
    role="status"
    aria-busy="true"
    data-testid="qualification-form-skeleton"
    className="flex flex-col gap-4"
  >
    <span className="sr-only">{qualificationText('regenerate.loading')}</span>
    <div aria-hidden="true" className="flex flex-col gap-4">
      <div className="flex gap-1">
        {TAB_WIDTHS.map((width, index) => (
          <div key={index} className={`h-8 ${width} ${BLOCK_CLASS}`} />
        ))}
      </div>
      <SkeletonField />
      <SkeletonField fieldClassName="h-40" />
      <div className="grid grid-cols-2 gap-3">
        <SkeletonField />
        <SkeletonField />
      </div>
      <SkeletonField />
      <SkeletonField fieldClassName="h-16" />
    </div>
  </div>
);

export default QualificationFormSkeleton;
